module.exports = __webpack_public_path__ + "static/media/90400-Bronze.443c8845.png";